import { render } from "./TimeSlotsList.vue?vue&type=template&id=0c0c8c3c&ts=true"
import script from "./TimeSlotsList.vue?vue&type=script&lang=ts"
export * from "./TimeSlotsList.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__